import React from 'react';

/**
 * Compact summary of resources_used — replaces raw JSON manifest in Simple mode.
 */
export default function DependenciesSummary({
    resourcesUsed
}) {
    const r = resourcesUsed || {};
    const llms = Array.isArray(r.llms) ? r.llms.length : 0;
    const apis = Array.isArray(r.apis) ? r.apis.length : 0;
    const collections = Array.isArray(r.collections) ? r.collections.length : 0;
    const tools = Array.isArray(r.tools) ? r.tools.length : 0;
    const subflows = Array.isArray(r.subflows) ? r.subflows.length : 0;
    const parts = [];
    if (llms) parts.push(`${llms} instruction${llms === 1 ? '' : 's'}`);
    if (apis) parts.push(`${apis} API${apis === 1 ? '' : 's'}`);
    if (collections) parts.push(`${collections} collection${collections === 1 ? '' : 's'}`);
    if (tools) parts.push(`${tools} tool${tools === 1 ? '' : 's'}`);
    if (subflows) parts.push(`${subflows} subflow${subflows === 1 ? '' : 's'}`);

    if (parts.length === 0) {
        return (
            <span className="text-[11px] text-muted-foreground">
                No external dependencies yet
            </span>
        );
    }

    return (
        <span className="text-[11px] text-muted-foreground">
            Uses: {parts.join(' · ')}
        </span>
    );
}
